import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:directive-selector
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `input[trimAndUppercase], textarea[trimAndUppercase]`,
})
export class TrimAndUppercaseValueAccessorDirective {
  @HostListener('input', ['$event']) onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;
    const cursorPosition = this.el.nativeElement.selectionStart;
    this.el.nativeElement.value = initialValue.toUpperCase();
    this.ngControl?.control?.setValue(this.el.nativeElement.value);
    this.el.nativeElement.setSelectionRange(cursorPosition, cursorPosition);
    event.stopPropagation();
  }

  @HostListener('blur', ['$event.target.value']) onBlur(val: string) {
    const normalizedValue = val.trim().toUpperCase();
    if (normalizedValue !== val) {
      this.el.nativeElement.value = normalizedValue;
      this.ngControl?.control?.setValue(normalizedValue);
    }
  }

  constructor(private el: ElementRef, @Optional() private ngControl?: NgControl) {}
}
